/* ═══════════════════════════════════════════════════════════════════════════
   UPPER BODEGA — optimistic paint for the card buy row.
   ───────────────────────────────────────────────────────────────────────────
   The theme's <card-actions> (global.js:1394) only repaints AFTER the network
   round-trip, and that request asks Shopify to re-render the whole cart drawer
   section, so the pill sat unchanged for a noticeable beat after every tap.

   This paints the new state on the click itself, then lets card-actions
   reconcile from the server's answer. It deliberately does NOT touch the cart:
   no fetch, no state of its own. If the request fails, card-actions' own
   response handling remains the single source of truth.

   Runs in the CAPTURE phase so the paint lands before card-actions starts
   fetching in the bubble phase.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PENDING = 'is-busy';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ub-scope .buy [data-action-button]');
    if (!btn) return;

    var el = btn.closest('card-actions');
    if (!el || el.hasAttribute('disabled')) return;

    var input = el.querySelector('[data-quantity]');
    var current = parseInt(el.getAttribute('data-product-quantity') || '0', 10);
    if (isNaN(current)) current = 0;

    var max = parseInt((input && input.getAttribute('max')) || '99', 10);
    if (isNaN(max) || max <= 0) max = 99;

    var increase = btn.getAttribute('data-action-button') === 'increase';
    var next = increase ? current + 1 : current - 1;
    if (next < 0) next = 0;
    if (next > max) next = max;
    if (next === current) return;

    el.setAttribute('data-product-quantity', String(next));
    el.setAttribute('data-closed', next === 0 ? 'true' : 'false');
    if (input) input.value = String(next);

    /* re-trigger the count animation */
    if (input) {
      input.classList.remove('ub-pop');
      void input.offsetWidth;
      input.classList.add('ub-pop');
    }

    el.classList.add(PENDING);

    /* clear the pending state as soon as card-actions writes the real answer */
    if (!el.__ubObserver) {
      el.__ubObserver = new MutationObserver(function () {
        el.classList.remove(PENDING);
      });
      el.__ubObserver.observe(el, { attributes: true, attributeFilter: ['data-product-quantity'] });
    }
    clearTimeout(el.__ubTimer);
    el.__ubTimer = setTimeout(function () { el.classList.remove(PENDING); }, 6000);
  }, true);
})();
